// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

require('!style-loader!css-loader!sass-loader!./assets/css/common.scss');
import './icons' // icon
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'

import $ from 'expose-loader?$!jquery'

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo);


import bus from './assets/js/bus'


import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper);
//配置请求头
import VueResource from 'vue-resource'
Vue.use(VueResource);

import onlyNumber from '@/directive/el-input'; //添加此行=>自定义全局指令
Vue.use(onlyNumber); //添加此行=>使用该全局指令
import router from './router'
Vue.config.productionTip = false;

import store from './store'
import cookie from './assets/js/cookie';
import JsEncrypt from 'jsencrypt/bin/jsencrypt'
Vue.prototype.$jsEncrypt = JsEncrypt;
//自定义input组件全局注册
import directiveInput from './components/apartment/directiveInput'
Vue.component('directive-input', directiveInput);
//设置timeout
Vue.http.options.timeout = 100000;

//路由的前置处理
router.beforeEach((to, from, next) => {
  if (to.path != '/login' &&
      to.path != '/register' &&
      to.path != '/forget' &&
      to.path != '/IRR' &&
      to.path != '/registerSuccess') {
    // 判断该路由是否需要登录权限
    var userToken = cookie.getCookie("userToken");
    if (userToken != undefined && userToken != "") {
      store.commit('hideMenu',{
        state:true
      });
      if (to.path == '/') {
        if (cookie.getCookie("roleName") == "FINANCE") {
          //财务进入首页时,跳转到费用明细页（权限控制）
          next("/feeDetail");
        } else if (cookie.getCookie("roleName") == "OTHER") {
          //其他工作人员进入首页时,跳转到工单页（权限控制）
          next("/sheet");
        } else if (cookie.getCookie("operatorType") == "RESIDENCE") {
          //用户只有分散式房源时,跳转到分散式房源首页
          next("/residence");
          //
          /*setTimeout(function () {
            window.location.reload()
          },500)*/
        } else {
          next("/index")
        }
      } else {
        next();
      }
    }
    else {
      next("/login");
    }
  } else {
    store.commit('hideMenu',{
      state:false
    });
    next();
  }
});

router.afterEach((to, from) => {
  let path;
  if(to.path.substr(1,to.path.length - 1).indexOf('/') != -1){
    path  = "/"+ to.path.substr(1,to.path.length-1).split('#').pop().split('/')[0];
    store.commit('getPath',{path:path});
  }
  setTimeout(function(){
    store.commit('activeMenu',to.path);
    bus.$emit('changeWidth');
  },500);
  //防止页面跳转后保留在之前页面滚动到的位置
  window.scrollTo(0, 0);
  if(to.path.indexOf('roomDetail') != -1 || to.path.indexOf('apartmentDetail') != -1  || to.path.indexOf('residence') != -1||to.path.indexOf('addOwnerContract') != -1){
    setTimeout(function(){
      window.addEventListener('scroll', scrollAction);
    },1000)
  } else {
    window.removeEventListener('scroll', scrollAction);
  }
});
/*beforeRouteLeave(to, from, next){
  let position = window.scrollY()
  this.$store.commit('SAVE_POSITION', position) //离开路由时把位置存起来
  next()
}*/

function scrollAction(){
  bus.$emit('scrollAction');
}

new Vue({
  el: '#app',
  store,
  router,
  template:'<APP/>',
  components:{App},
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js